import { GPIOMode } from '@iotize/tap/service/impl/gpio';
import { VariableType } from '@iotize/tap/service/impl/variable';

export const CONFIGURE_MASK = 0x80000000;

const DIRECT_ACCESS_GPIO = 0x40;
export const DIRECT_ACCESS_GPIO_FORMAT =
  DIRECT_ACCESS_GPIO | VariableType.Data.INT8;

export interface GPIOWriteConfig {
  /**
   * Indexes to write
   */
  indexs: number[];
  /**
   * Mode to write for all given indexes
   */
  mode: GPIOMode;
}
